import { AccountNotFoundError } from "@alchemy/aa-core";
import { SessionKeyPlugin } from "./plugin.js";
export const buildSessionKeysToRemoveStruct = async (client, { keys, pluginAddress, account = client.account }) => {
    if (!account)
        throw new AccountNotFoundError();
    const contract = SessionKeyPlugin.getContract(client, pluginAddress);
    return (await Promise.all(keys.map(async (key) => {
        return [
            key,
            await contract.read.findPredecessor([account.address, key]),
        ];
    }))).map(([key, predecessor]) => ({
        sessionKey: key,
        predecessor,
    }));
};
//# sourceMappingURL=utils.js.map